import React, {useState} from 'react';
import ModalWindow from '../modal-window';
import {useIntl} from 'react-intl';
import {ButtonVariant, GritxButton} from '@wholesalechange/chatcomponent';
import Input from '../input';

import './style.scss';
import {INewPost} from '../../redux/chatroom/interfaces';

interface IChatroomModalWindow {
  card: INewPost
  title: string
  onSave: (card: INewPost) => void
  onClose: () => void
  show: boolean
}

export const ChatroomModalWindow = (
  {
    card,
    title,
    onSave,
    onClose,
    show
  }: IChatroomModalWindow
): JSX.Element => {
  const intl = useIntl();
  const [post, setPost] = useState<INewPost>(card);

  function handleClose() {
    setPost(card);
    onClose();
  }

  function handleSave() {
    onSave(post);
  }

  function handleChange(type: string): (e: string) => void {
    return (e) => {
      const newPost = {
        ...post,
        [type]: e
      };

      setPost(newPost);
    };
  }

  const content = () => {
    return <div className={'chatroom-form__container'}>
      <div className={'form-chatroom'}>
        <div className="form-chatroom__header">
          <h2 className="form-chatroom__title">{title}</h2>
        </div>
        <div className="form-chatroom__body">
          <Input
            required
            type="text"
            value={post.name}
            label={intl.formatMessage({
              id: 'gritx.chatroom.chatroomForm.name.label',
              defaultMessage: 'Chat title'
            })}
            onChange={handleChange('name')}
          />
          <Input
            required
            type="text"
            value={post.text}
            label={intl.formatMessage({
              id: 'gritx.chatroom.chatroomForm.text.label',
              defaultMessage: 'Please enter your question'
            })}
            onChange={handleChange('text')}
          />
        </div>
      </div>
    </div>;
  };

  const formsButtons = () => {
    return <div className="chatroom-form__footer">
      <GritxButton
        title={intl.formatMessage({
          id: 'gritx.common.button.cancel',
          defaultMessage: 'Cancel'
        })}
        variant={ButtonVariant.Light}
        className="chatroom-form__button"
        onClick={handleClose}
      />
      <GritxButton
        title={intl.formatMessage({
          id: 'gritx.common.button.save',
          defaultMessage: 'Save'
        })}
        variant={ButtonVariant.Primary}
        className="chatroom-form__button"
        onClick={handleSave}
      />
    </div>;
  };

  return <ModalWindow
    show={show}
    className="chatroom-form__modal"
    onHide={handleClose}
    footerElement={formsButtons()}
  >
    {content()}
  </ModalWindow>;
};
